import React from 'react';

import { Section, preloader } from 'spectacle-ppa';

import headingSlide from '../../baseSlides/headingSlide';
import balloonSlide from '../../baseSlides/balloonSlide';
import videoSlide from '../../baseSlides/videoSlide';

import imageEPSLogo from '../../images/emergencyPreparednessSquadGlow.png';
import ianSaraSide from '../../images/characters/ian_sara_side.png';
import ianSaraLeanQuestioning from '../../images/characters/ian_sara_lean_questioning.png';

import MarkdownScript from 'helpers/markdownScript';
import markdownFileLevel1 from './level1_makeAPlan.md';
import markdownFileLevel2 from './level2_getAKit.md';
import markdownFileLevel3 from './level3_keepBuildingKit.md';

const levels = {
  '1': { md: new MarkdownScript(markdownFileLevel1) },
  '2': { md: new MarkdownScript(markdownFileLevel2) },
  '3': { md: new MarkdownScript(markdownFileLevel3) }
};

export function preloadMissionAssignment () {
  preloader([
    imageEPSLogo,
    ianSaraSide,
    ianSaraLeanQuestioning
  ]);
}

function missionAssignmentSection ({ level, title, regionData }) {
  const md = levels[level].md;
  return (
    <Section id="mission-assignment">

      {/* Mission Intro Video*/}
      {videoSlide({
        id: 'mission-intro-video',
        notes: md.getSubSectionAsHtml('Mission Intro Video', 'Notes', false, regionData),
        youTubeId: md.getSectionMetadata('Mission Intro Video', 'YouTube', regionData)
      })}

      {/* Sizzle */}
      {headingSlide({
        id: 'sizzle',
        beforeImage: imageEPSLogo,
        subHeading: `Mission ${level}:<br/> ${title}`,
        notes: md.getSubSectionAsHtml('Mission Assignment', 'Notes', false, regionData),
        bgColor: 'black'
      })}

      {/* Mission Instructions levels 1 & 3 */}
      { (level === 1 || level === 3) &&
        balloonSlide({
          id: 'instructions',
          characterSide: 'right',
          characterImage: ianSaraSide,
          notes: md.getSubSectionAsHtml('Instructions', 'Notes', false, regionData),
          html: md.getSubSectionAsHtml('Instructions', 'Content', false, regionData)
        })
      }

      {/* Mission Instructions levels 2 */}
      { (level === 2) &&
        balloonSlide({
          id: 'instructions',
          characterSide: 'right',
          characterImage: ianSaraLeanQuestioning,
          notes: md.getSubSectionAsHtml('Instructions', 'Notes', false, regionData),
          html: md.getSubSectionAsHtml('Instructions', 'Content', false, regionData)
        })
      }

    </Section>
  );
}

export default missionAssignmentSection;



// WEBPACK FOOTER //
// ./programs/epsHybridIntermediates/sections/70_missionAssignment/missionAssignmentSection.jsx